import { DialogController } from 'aurelia-dialog';
import { autoinject } from 'aurelia-framework';
import { calculateFactorsMbl } from '../factors';
import { MaterialFactorService } from 'services/material-factor-service';
import { MaterialFactor } from 'models/mooring/MaterialFactor';

export type BridleCage = {
  CageMooringNo: string;

  write?: boolean;

  DimForce: number;
  hasMultipleDimForce: boolean;

  MblRopes: number;
  hasMultipleMblRopes: boolean;

  MblSinkRopes: number;
  hasMultipleMblSinkRopes: boolean;

  MblStraps: number;
  hasMultipleMblStraps: boolean;

  MblChainShackleConnectionPlates: number;
  hasMultipleMblChainShackle: boolean;

  MblUsedChainRopeWithKnot: number;
  hasMultipleMblUseChainRope: boolean;
};

export type BridleCageDialogResult = {
  CageMooringNo: string;
  DimForce: number;

  MblStraps: number;
  MblRopes: number;
  MblSinkRopes: number;
  MblChainShackleConnectionPlates: number;
  MblUsedChainRopeWithKnot: number;
};

export type BridleCageDialogArgs = {
  bridleCages: BridleCage[];
};

@autoinject
export class BridleCageDialog {
  lines: BridleCage[] = [];
  protected materialFactors: MaterialFactor;

  constructor(
    private dialogController: DialogController,
    private materialFactorService: MaterialFactorService
  ) {}

  async activate(args: BridleCageDialogArgs) {
    await this.getMaterialFactors();
    this.lines = args.bridleCages;
  }

  protected async getMaterialFactors() {
    const response = await this.materialFactorService.getActiveMaterialFactors();
    this.materialFactors = response.data;
  }

  protected async onCancel() {
    await this.dialogController.cancel();
  }

  protected async onSelectAll() {
    this.lines.forEach((line) => (line.write = true));
  }

  protected async onClearSelections() {
    this.lines.forEach((line) => (line.write = false));
  }

  protected onDimForceChange(line: BridleCage) {
    calculateFactorsMbl(line.DimForce, line, this.materialFactors);
  }

  protected async onCommit() {
    await this.dialogController.ok(
      this.lines
        .filter((line) => line.write)
        .map((line) => {
          return {
            CageMooringNo: line.CageMooringNo,
            DimForce: line.DimForce,
            MblRopes: line.MblRopes,
            MblSinkRopes: line.MblSinkRopes,
            MblStraps: line.MblStraps,
            MblChainShackleConnectionPlates: line.MblChainShackleConnectionPlates,
            MblUsedChainRopeWithKnot: line.MblUsedChainRopeWithKnot,
          } satisfies BridleCageDialogResult;
        })
    );
  }
}
